import { check, LEVELS, Logger } from '~/shared/logger'

/**
 * Root logger for Analytix feature internals.
 */
export const logger = new Logger(
  'tria/features/analytix',
  undefined,
  LEVELS.error
)

/**
 * Helper for component-specific error-only loggers.
 */
export const errorLogger = (name: string) =>
  new Logger(`tria/features/analytix/${name}`, undefined, LEVELS.error)

const isLogLevel = check('tria/features/analytix')

/**
 * Runtime guard for trace-level diagnostics.
 */
export const isTrace = () => isLogLevel(LEVELS.trace)
